import { useEffect } from 'react';
import { useAccountChanges } from '@/modules/mcpStream';
import { loadThemes } from './themeStore';

/** Reads the themes table on every page, signed in or not, and again whenever a theme changes elsewhere (the account change stream). */
export function ThemeRowsSync() {
  useEffect(() => {
    void loadThemes();
  }, []);
  useAccountChanges(['theme'], () => void loadThemes(), 500);
  return null;
}
